/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Announcement_Section_TitleInputs */



/**
* | output |
* | --- |
* | "Announcements" |
*
* @param {Announcement_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const announcement_section_title = /** @type {((inputs?: Announcement_Section_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Announcement_Section_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annonces")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anuncios")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Anúncios")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annunci")
	return /** @type {LocalizedString} */ ("Announcements")
});